@reference "@glow/tailwind-config/reference.css";

.card {
  @apply mt-2;
  @apply p-4;
  @apply grid;
  @apply items-center;
}
.animation {
  animation: slide-out 0.5s;
}
@keyframes slide-out {
  0% {
    transform: translateX(0);
    opacity: 0;
  }
  100% {
    transform: translateX(100%);
    opacity: 1;
  }
}
